import { SvgIcon } from '@mui/material';

export function Polygon() {
  return (
    <SvgIcon>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M2 4.8V22h20V2l-11.538 8.4zm19-.835V21H3V6.661l7.489 4.956z" />
        <path fill="none" d="M0 0h24v24H0z" />
      </svg>
    </SvgIcon>
  );
}
